import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import "./SearchCars.css";
import SearchCarsSection from "../Components/SearchCarsSection";

const SearchCars = () => {
  const [cars, setCars] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 50;

  const navigate = useNavigate();
  const { maker } = useParams();

  useEffect(() => {
  if (!maker) return;

  fetch(`https://api.saadmotors.com/getCars.php?maker=${maker}`)
      .then(res => res.json())
      .then(data => setCars(data))
      .catch(err => console.error(err));
  }, [maker]);
  
      // const handleViewVehicle = (carId) => {
      //     navigate(`/vehicle-details/${carId}`);
      // };


 const filteredCars = maker
  ? cars.filter(
      (car) => car.maker?.toLowerCase() === maker.toLowerCase()
    )
  : cars;

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = cars.slice(indexOfFirstItem, indexOfLastItem);

  // const handleViewVehicle = (id) => {
  //   navigate(`/${id}`);
  // };

  const handleViewVehicle = (id) => {
    navigate(`/vehicle-details/${id}`);
  };

  const handleViewVehicles = (maker) => {
    navigate(`/${maker.toLowerCase()}`);
  };

  return (
    <div className="row">
      <div className="col-lg-12 middlecol">
        <SearchCarsSection />
        <hr className="title-line" />

        {/* ✅ HONDA CARS LIST */}
          {currentItems.length === 0 ? (
            <p>No cars found</p>
          ) : (
            currentItems.map((car) => (
              // <div key={car.id} className="car-show">
              //   <div className="row">
              //     <div className="col-lg-6">
              //       <img
              //         src={`https://api.saadmotors.com/${car.images}`}
              //         alt={car.model}
              //         style={{ cursor: "pointer" }}
              //         onClick={() => handleViewVehicle(car.id)}
              //       />
              //     </div>

              //     <div className="col-lg-6">
              //       <h3>{car.maker} {car.model} {car.year}</h3>
              //       <h4>$ {car.price}</h4>
              //     </div>
              //   </div>
              //   <hr />
              // </div>

              <div key={car.id} className="row car-show">
                  <div className="col-lg-4">
                    <img
                      src={`https://api.saadmotors.com/${car.images}`}
                      alt={car.model}
                      style={{ cursor: "pointer" }}
                      onClick={() => handleViewVehicle(car.id)}
                        />
                  </div>
                  <div className="col-lg-6">
                      <h3>{car.maker} {car.model} {car.year}</h3>
                      <p>Location: {car.country}</p>
                      <h4>&#xa5; {car.price}</h4>
                      <table className="table">
                          <thead>
                              <tr>
                                  <th>Engine</th>
                                  <td>{car.engine_size} CC</td>
                              </tr>
                              <tr>
                                  <th>Transmission</th>
                                  <td>{car.transmission}</td>
                              </tr>
                              <tr>
                                  <th>Color</th>
                                  <td>{car.color}</td>
                              </tr>
                              <tr>
                                  <th>Fuel</th>
                                  <td>{car.fuel}</td>
                              </tr>
                              <tr>
                                  <th>Mileage</th>
                                  <td>{car.mileage} KM</td>
                              </tr>
                          </thead>
                          <tbody>
                              
                          </tbody>
                      </table>
                  </div>
                  <div className="col-lg-2">
                      <button>Get Price Quote</button>
                      <button onClick={() => handleViewVehicle(car.id)}>View Vehicle</button>
                  </div>
                  <hr className="title-line my-4"></hr>
              </div>
            ))
          )}
        {/* ✅ PAGINATION */}
        <div className="pagination">
          {Array.from(
            { length: Math.ceil(filteredCars.length / itemsPerPage) },
            (_, i) => (
              <button
                key={i + 1}
                onClick={() => setCurrentPage(i + 1)}
                className={currentPage === i + 1 ? "active" : ""}
              >
                {i + 1}
              </button>
            )
          )}
        </div>
      </div>
    </div>
  );
};

export default SearchCars;